import { Box, Chip, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/if"
import { CriticalityDropdown } from "./criticality-dropdown"

const CHANGE_TYPE_LABELS = {
    schedule_title: "Schedule Title",
    intro_content: "Introduction",
    intro_note: "Introduction Note",
    task_content: "Task Content",
    task_note: "Task Note",
    task_title: "Task Title",
    task_frequency: "Task Frequency",
    add_task: "Add Task",
    remove_task: "Remove Task",
}

const CHANGE_TYPE_COLORS = {
    schedule_title: "info",
    intro_content: "primary",
    intro_note: "secondary",
    task_content: "primary",
    task_note: "secondary",
    task_title: "info",
    task_frequency: "warning",
    add_task: "success",
    remove_task: "error",
}

const CHANGE_TYPE_ICONS = {
    schedule_title: "mdi:rename-box",
    intro_content: "mdi:book-open-variant",
    intro_note: "mdi:book-open-page-variant-outline",
    task_content: "mdi:text-box-edit-outline",
    task_note: "mdi:note-edit-outline",
    task_title: "mdi:rename-outline",
    task_frequency: "mdi:calendar-edit-outline",
    add_task: "mdi:plus-circle-outline",
    remove_task: "mdi:delete-outline",
}

export { CHANGE_TYPE_COLORS }

export function ChangeItemHeader({ change, onCriticalityChange }) {
    const typeColor = CHANGE_TYPE_COLORS[change.changeType] ?? "default"
    const typeIcon = CHANGE_TYPE_ICONS[change.changeType]

    return (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            <Chip
                label={CHANGE_TYPE_LABELS[change.changeType] ?? change.changeType}
                size="small"
                color={typeColor}
                variant="outlined"
                icon={
                    <If truthy={typeIcon}>
                        <Iconify icon={typeIcon} sx={{ fontSize: "14px !important", ml: "6px !important" }} />
                    </If>
                }
            />
            <If truthy={change.taskNumber != null}>
                <Typography variant="body2" color="text.secondary">
                    Task {change.taskNumber}
                    <If truthy={change.taskTitle}> — {change.taskTitle}</If>
                </Typography>
            </If>
            <Box sx={{ flex: 1 }} />
            <CriticalityDropdown value={change.criticality ?? null} onChange={onCriticalityChange} />
        </Stack>
    )
}
